import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CoreModule } from './core/core.module';

// ---- NGX Spinner ----- //
import { NgxSpinnerModule } from 'ngx-spinner';

// ----- Material Date Picker Module ----- //
import { MatNativeDateModule, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { PickDateAdapter } from './shared';
import { DatePipe } from '@angular/common';

import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';

const APP_DATE_FORMATS: MatDateFormats = {
    parse: {
      dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
    },
    display: {
      dateInput: 'input',
      monthYearLabel: { year: 'numeric', month: 'short'},
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric'},
      monthYearA11yLabel: { year: 'numeric', month: 'long' }
    }
  };

// ---- Services ---- //
import { NotificationModule } from './core/services';

// ----- Root ----- //
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// --- Ngxs --- //
import { NgxsModule } from '@ngxs/store';
// import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
// import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { AppState } from './store';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [ AppComponent ],
  imports: [
    // ----- Vendor ----- //
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    HttpClientModule,

    NgxSpinnerModule,  // --- Added
    NotificationModule.forRoot(),   // --- Added

    MatNativeDateModule,  // ----Added

    NgxsModule.forRoot(AppState),
    // NgxsLoggerPluginModule.forRoot(),
    // NgxsReduxDevtoolsPluginModule.forRoot()
    MatCardModule,
    MatGridListModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAfTh78wnci0x1K77g-fYdi_q739TLCr2A'
    }),

  ],
  providers: [
      // { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
      { provide: DateAdapter, useClass: PickDateAdapter },
      { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
      DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
